import { render, staticRenderFns } from "./PriceTableAdd.vue?vue&type=template&id=52230d35&scoped=true"
import script from "./PriceTableAdd.vue?vue&type=script&lang=js"
export * from "./PriceTableAdd.vue?vue&type=script&lang=js"
import style0 from "./PriceTableAdd.vue?vue&type=style&index=0&id=52230d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52230d35",
  null
  
)

export default component.exports